import React, { useState } from "react";
import "../../../../../../../styles/shared/pending-payment-list.css";

// components imports
import ApprovedTransectionTable from "../../../../../../../Components/BoltTable/BoltTable";
import ImageModal from "../../Components/ImageModal/ImageModal";
import Tooltip from "../../../../../../../Components/Tooltip/Tooltip";
import noImage from "../../../../../../../assets/images/noImage.png";

// apis imports
import { fetchLtlPendingTransactions } from "../../../../../../../services/ShipperServices/Payments/payments.services";
import {
  convertTime,
  removeUnderscoresAndCapitalize,
} from "../../../../../../../helpers/helpers";
// library imports
import { FaArrowAltCircleUp } from "react-icons/fa";
import { MdOutlineStickyNote2 } from "react-icons/md";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ApprovePayment from "./ApprovePayment/ApprovePayment";

const LtlPendingPaymentList = ({ setSnack }) => {
  const { t } = useTranslation("finances");
  const [transections, setTransections] = useState([]);

  const [imageModal, setImageModal] = useState();
  const [approvePaymentModal, setApprovePaymentModal] = useState();
  const [refresh, setRefresh] = useState();

  const user = useSelector((state) => state.user);

  const getAllShippersTransections = async (page, perPage, filter) => {
    const response = await fetchLtlPendingTransactions(page, perPage, filter);
    if (!response.error) {
      setTransections(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("columns.transactionId"),
      field_name: "transaction_id",
      render: (row) => <>{row?.transaction_id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("columns.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("columns.paymentType"),
      field_name: "payment_type",
      render: (row) => (
        <>
          {row.payment_type
            ? removeUnderscoresAndCapitalize(row.payment_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: (
        <>
          {user?.role === "warehouseUser"
            ? t("columns.user")
            : t("columns.warehouse")}
        </>
      ),
      field_name: "warehouse_name",
      render: (row) => (
        <>
          {user?.role === "warehouseUser"
            ? row?.user?.username ?? "-"
            : row?.warehouse?.name ?? "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("columns.amount"),
      field_name: "amount",
      render: (row) => (
        <div
          style={{
            color:
              row?.transaction_type?.startsWith("credit") || true
                ? "teal"
                : "tomato",
            display: "flex",
          }}
        >
          <>
            {row.balance ?? "-"}
            <FaArrowAltCircleUp
              style={{ marginTop: "2px", marginLeft: "4px" }}
            />
          </>
        </div>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("columns.status"),
      field_name: "status",
      render: (row) => <>{row.status?.toUpperCase() ?? "-"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("columns.reference"),
      field_name: "reference",
      render: (row) => (
        <>
          <img
            src={row.file || noImage}
            style={{ cursor: "pointer" }}
            onClick={() => setImageModal(row.file || noImage)}
            onError={(e) => {
              e.target.src = noImage;
            }}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 9,
      label: t("columns.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          {user?.role === "warehouseUser" && (
            <Tooltip title={t("ltl.approveBalance")}>
              <div
                className="table_action__btn"
                onClick={() => setApprovePaymentModal(row)}
              >
                <MdOutlineStickyNote2 size={10} />
                {t("ltl.approve")}
              </div>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <div>
        <ImageModal open={imageModal} setOpen={setImageModal} />

        <ApprovePayment
          open={!!approvePaymentModal}
          setOpen={setApprovePaymentModal}
          previousData={approvePaymentModal}
          setRefresh={setRefresh}
        />

        <ApprovedTransectionTable
          tableTitle={t("transactions.title")}
          tableId="approvedPaymentsTable2forShipper"
          message={t("transactions.emptyPending")}
          searchPlaceHolder={t("transactions.search")}
          getAllData={getAllShippersTransections}
          data={transections}
          columns={columns}
          refresh={refresh}
        />
      </div>
    </div>
  );
};

export default LtlPendingPaymentList;
